import dom_ready from './shared/dom-ready';

import { init as navbar_init } from './navbar';

dom_ready( navbar_init );
